import { writable } from "svelte/store";

const createDarkMode = () => {
  const { subscribe, set, update } = writable(undefined);

  return {
    subscribe,
    update: (val) => set(val),
    toggle: () => update((n) => !n),
    close: () => set(false),
    open: () => set(true),
    // increment: () => update(n => n + 1),
    // decrement: () => update(n => n - 1),
    reset: () => set(false),
  };
};

export const DarkModeStore = createDarkMode();
